// Modal.js
import React from 'react';
import '../assets/templates/Modal.css';

const Modal = ({ isOpen, onClose, isLoading, onActionButtonClick, message, actionButtonText }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>
          Fechar
        </button>
        <div className='modal-content-header'>
          {
            !isLoading &&
            <p className='modal-message'>{message}</p>
          }
          {
            isLoading &&
            <div className="spinner-border" style={{color: "#33aae3bd"}} role="status">
              <span className="sr-only">Loading...</span>
            </div> 
          }
        </div>
        <button className="action-button" onClick={onActionButtonClick}>
          {actionButtonText}
        </button>
      </div>
    </div>
  );
};


export default Modal;
